import { useQuery } from '@tanstack/react-query';
import { KnowledgeManagerPage } from './KnowledgeManager.page';
import { CenterSpinner } from '@/Domain/components/Shared/CenterSpinner/CenterSpinner';

export const KnowledgeManagerLoader = () => {
  const { isLoading } = useQuery<any>({ queryKey: ['knowledge_base'] });

  if (isLoading) {
    return <CenterSpinner />;
  }

  return <KnowledgeManagerPage />;
};
